// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Table_table-roles__\\+ap5Q {
  margin-bottom: 5px;
}
.Table_table-roles__\\+ap5Q .Table_green__Xg0Rb {
  border-radius: 3px;
  border: 1px solid var(--institution-role);
  color: var(--institution-role);
  color: #289a00;
  width: fit-content;
  padding: 3px 10px;
  font-weight: 600;
}
.Table_table-roles__\\+ap5Q .Table_gold__u1zCP {
  border-radius: 3px;
  border: 1px solid var(--personal-role);
  color: var(--personal-role);
  width: fit-content;
  padding: 3px 10px;
  font-weight: 600;
}
.Table_table-roles__\\+ap5Q .Table_purple__xsavO {
  border-radius: 3px;
  border: 1px solid var(--unit-role);
  color: var(--unit-role);
  width: fit-content;
  padding: 3px 10px;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/SuperAdmin/Pages/RoleList/Components/Table/Table.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;AAAE;EACE,kBAAA;EACA,yCAAA;EACA,8BAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;AAEJ;AAAE;EACE,kBAAA;EACA,sCAAA;EACA,2BAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;AAEJ;AAAE;EACE,kBAAA;EACA,kCAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;AAEJ","sourcesContent":[".table-roles {\n  margin-bottom: 5px;\n  .green {\n    border-radius: 3px;\n    border: 1px solid var(--institution-role);\n    color: var(--institution-role);\n    color: #289a00;\n    width: fit-content;\n    padding: 3px 10px;\n    font-weight: 600;\n  }\n  .gold {\n    border-radius: 3px;\n    border: 1px solid var(--personal-role);\n    color: var(--personal-role);\n    width: fit-content;\n    padding: 3px 10px;\n    font-weight: 600;\n  }\n  .purple {\n    border-radius: 3px;\n    border: 1px solid var(--unit-role);\n    color: var(--unit-role);\n    width: fit-content;\n    padding: 3px 10px;\n    font-weight: 600;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table-roles": `Table_table-roles__+ap5Q`,
	"green": `Table_green__Xg0Rb`,
	"gold": `Table_gold__u1zCP`,
	"purple": `Table_purple__xsavO`
};
export default ___CSS_LOADER_EXPORT___;
